<script setup lang="ts">
  import type { HTMLAttributes } from 'vue';
  import { ChevronDown, ChevronRight, Minus, Plus } from 'lucide-vue-next';
  import { cn } from '@/shared/lib/utils';

  const props = withDefaults(
    defineProps<{
      hasChildren?: boolean;
      isExpanded?: boolean;
      toggleIconType?: 'chevron' | 'plus-minus';
      class?: HTMLAttributes['class'];
    }>(),
    {
      hasChildren: false,
      isExpanded: false,
      toggleIconType: 'chevron',
    }
  );

  const emit = defineEmits<{
    (e: 'toggle'): void;
  }>();
</script>

<template>
  <div
    data-slot="tree-item-label"
    :class="cn('flex min-w-0 flex-1 items-center gap-2', props.class)"
  >
    <button
      v-if="hasChildren"
      type="button"
      class="flex size-5 shrink-0 cursor-pointer items-center justify-center rounded text-[var(--theme-secondary-ink)]"
      :aria-expanded="isExpanded"
      @click.stop="emit('toggle')"
    >
      <template v-if="toggleIconType === 'plus-minus'">
        <Minus
          v-if="isExpanded"
          class="size-3.5"
        />
        <Plus
          v-else
          class="size-3.5"
        />
      </template>
      <template v-else>
        <ChevronDown
          v-if="isExpanded"
          class="size-4"
        />
        <ChevronRight
          v-else
          class="size-4"
        />
      </template>
    </button>
    <span
      v-else
      class="size-5 shrink-0"
      aria-hidden="true"
    />
    <span class="min-w-0 flex-1 truncate">
      <slot />
    </span>
  </div>
</template>
